import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {reverseShortDate} from '../../common/constants/datesFormat';
import moment from 'moment';

const INITIAL_STATE_ANTICIPATED_INVOICE = {
  'vehiclesList': [],
  'loading': false,
  'tasksValidation': [],
  'notificationSent': false,
};

const addCheckedField = (list) => {
  const newList = [...list];
  newList.map((element) => {
    if (element.anticipatedInvoice === 'S') {
      return element.checked = true;
    }
    return element.checked = false;
  });
  return newList;
};

const formatDateFields = (data) => {
  return data.map((item) => {
    return {...item,
      'dateMod': moment(item.dateMod).format(reverseShortDate),
      'pdsDate': moment(item.pdsDate).format(reverseShortDate),
    };
  });
};

export const anticipatedInvoice = (state, action) => {
  return createReducer(INITIAL_STATE_ANTICIPATED_INVOICE, {
    [ActionTypes.FETCHING_ANTICIPATED_INVOICE_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
      'vehiclesList': [],
    }),
    [ActionTypes.FETCHED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'vehiclesList': [],
    }),
    [ActionTypes.FETCHED_ANTICIPATED_INVOICE_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'vehiclesList': addCheckedField(formatDateFields(action.response.data, [])),
    }),
    [ActionTypes.SAVING_ANTICIPATED_INVOICE_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
      'tasksValidation': [],
    }),
    [ActionTypes.SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'tasksValidation': action.response.tasks_validation,
    }),
    [ActionTypes.SAVED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'tasksValidation': [],
    }),
    [ActionTypes.RESTORE_TASKS_VALIDATION_VALUE]: (state, action) => ({
      ...state,
      'tasksValidation': [],
    }),
    [ActionTypes.NOTIFICATING_ANTICIPATED_INVOICE_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'loading': true,
      'notificationSent': false,
    }),
    [ActionTypes.NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'notificationSent': true,
    }),
    [ActionTypes.NOTIFICATED_ANTICIPATED_INVOICE_VEHICLES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'notificationSent': false,
    }),
  })(state, action);
};
